<style lang="less">
@import "../../../styles/common-table-list.less";
</style>
<template>
    <div class="generalframezz">
        <div class="generalcontent" :style="{width:mywidth+'px',height:myheight+'px'}">
            <div :style="{height:myTitleheight+'px',lineHeight:myTitleheight+'px'}" class="general_title">
                <div class="general_title_left">
                    <div>保险计划详情解读</div>
                </div>
                <img @click="parentHandleclick()" class="timgclose" src="../user/more/images/ty_close.png" alt='版权登记'/>
            </div>
            <div class="fangan">
                <ul>
                    <li>
                        <span>项目</span>
                        <span>保险方案</span>
                    </li>
                    <li>
                        <span>投保人/被保险人</span>
                        <span>通过“北京版全家科技发展有限公司”区块链存证权属证据保全或已通过中国版权局登记确权的著作权权利人</span>
                    </li>
                    <li>
                        <span>保险责任</span>
                        <span style="">
                            在保险期间内，第三方未取得合法有效许可或授权而实施、使用投保知识产权，被保险人在保险期间内就该侵权行为向法院提起诉讼，并被法院受理的，依据最终生效的判决书判定应由被保险人承担的诉讼费用，保险人按照本保险合同约定负责赔偿。<br/>
保险事故发生的时间以一审法院案件受理时间为准。<br/>
承保在上述维权过程中，法院在审理案件过程中，对于被保险人通过“北京版全家科技发展有限公司”区块链存证平台进行区块链权属证据存证的权属证据或区块链保全取证的侵权证据，受理法院对于取证方式不予认可，并以此判决被保险人起诉证据不足的，对于被保险人实际发生的律师费用损失，在保单约定的赔偿限额内，保险人予以赔偿，每次事故律师费用赔偿限额：2000元。<br/>
保险事故发生的时间以一审法院案件受理时间为准。<br/>
前述“受理法院对于取证方式不予认可”须在法院判决书里载明，对于法院判决书未明确载明的案件驳回原因或判决事由中无明确表述的，保险人不承担赔偿责任。<br/>
本责任仅保障受理法院对于“北京版全家科技发展有限公司”区块链权属证据或区块链侵权证据保全取证的证据形式不予认可而导致的损失。对于因为证据本身存在缺陷、瑕疵或缺失而导致的损失，保险人不负责赔偿。所指法院仅包括北京互联网法院、杭州互联网法院、广州互联网法院、北京知识产权法院、上海知识产权法院、广州知识产权法院。</span>
                    </li>
                    <li>
                        <span>赔偿限额</span>
                        <span>累计赔偿限额：5000元，其中：每次事故诉讼费用赔偿限额：3000元</span>
                    </li>
                    <li>
                        <span>保险期限</span>
                        <span>一年</span>
                    </li>
                    <li>
                        <span>保险起期</span>
                        <span>投保日期次日0时起生效</span>
                    </li>
                    <li>
                        <span>免赔额（率）</span>
                        <span>无</span>
                    </li>
                    <li>
                        <span>保险费</span>
                        <span>5元</span>
                    </li>
                    <li>
                        <span>特别约定</span>
                        <span>1、本保险指定维权服务公司详见清单，被保险人在维权过程中聘请其他代理机构的，保险人不承担赔偿责任。<br/>
2、投保人在投保前前已知晓的第三方侵权行为而导致的损失，保险人不负责承担赔偿责任。</span>
                    </li>
                    <li>
                        <span>保险条款</span>
                        <span>《国任财产保险股份有限公司知识产权维权诉讼费用损失保险条款》</span>
                    </li>
                    <li>
                        <span>保险人</span>
                        <span>国任财产保险股份有限公司北京分公司</span>
                    </li>
                    <li>
                        <span>投保资料</span>
                        <span>
                            1、投保人/被保险人信息：<br/>
                            1）客户类型<br/>
                            2）客户姓名<br/>
                            3）证件类型<br/>
                            4）证件号码<br/>
                            2、标的信息<br/>
                            1）知识产权类型<br/>
                            2）著作权权利人<br/>
                            3）著作权登记或存证号<br/>
                            4）著作权登记或存证日期<br/>
                            5）著作权权属确认机构名称
                        </span>
                    </li>
                    <li>
                        <span>理赔资料</span>
                        <span>
                            1、起诉状等提起诉讼材料<br/>
                            2、法院立案书面证明材料<br/>
                            3、法院判决书<br/>
                            4、诉讼费用支付凭证<br/>
                            5、律师费用支付凭证<br/>
                            6、其他案件证明材料
                        </span>
                    </li>
                    <li style="border:none">
                        <span>司法管辖</span>
                        <span>中华人民共和国（港、澳、台除外）</span>
                    </li>
                </ul>
            </div>
                        
        </div>
    </div>
</template>

<script>
    export default {
        name:'insuranceModel',
        props:{
            mywidth:{
                type:String,
                default:'800'
            },
            myheight:{
                type:String,
                default:'580'
            },
            myTitleheight:{
                type:String,
                default:'63'
            },
            tishihide:{
                type:Boolean,
                default:true
            }
        },
        data(){
            return{
                
            }
        },
        methods:{
            parentHandleclick() {
               this.$emit('fatherModal');
            },  
        },
        mounted(){
          
        }
    }
</script>

<style scoped lang="less">
    .generalframezz{
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        margin: auto;
        z-index: 558;
        .fangan{
            width: 800px;
            padding: 20px;
            height:520px;
            overflow: auto;
            ul{
                width: 100%;
                // padding: 20px;
                height: 100%;
                overflow: auto;
                border: 1px solid #e5e5e5;
                li{
                    display: flex;
                    list-style: none;
                    border-bottom: 1px solid #e5e5e5;
                    span{
                        text-align: left;
                        line-height:20px ;
                        padding:13px;
                    }
                    span:nth-of-type(1){
                        width: 150px;
                        border-right: 1px solid #e5e5e5;
                    }
                    span:nth-of-type(3){
                        width: 150px;
                    }
                    span:nth-of-type(2){
                        flex:1;
                        // border-right: 1px solid #e5e5e5;
                    }
                }
                li:nth-of-type(1){
                    background:#F2F2F2 ;
                    // height: 44px;
                    span{
                        // line-height: 44px;
                        font-size: 16px;
                        font-weight: 600;
                        color: #282828;
                    }
                }
                li:nth-of-type(2){
                    // height:68px;
                }
            }
        }
        .generalcontent{
            background:#fff;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            border-radius:8px;
            .general_title{
                background:rgba(255,255,255,1);
                box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
                border-radius:8px 8px 0px 0px;
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
                display:flex;
                justify-content: space-between;
                padding:0 30px 0 20px;
                align-items: center;
                .general_title_left{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                }
                .timgtishi{
                    width:25px;
                    height:25px;
                    margin-right:10px;
                }
                .timgclose{
                    width:18px;
                    height:18px;
                    cursor: pointer;
                }
            }
            .modal-title{
                margin:15px 0 9px 20px;
                font-size:14px;
                font-weight:400;
                color:rgba(102,102,102,1);
                text-align: left;
            }
            .invice-table-title{
                width:559px;
                height:40px;
                line-height: 40px;
                text-align: center;
                background:rgba(251,251,251,1);
                margin:0 20px;
            }
            .invice-table-content{
                width: 559px;margin: 0 auto;
                font-size:14px;
                font-weight:400;
                color:rgba(153,153,153,1);
                border-bottom: 1px solid #EEEEEE;
                div{
                    margin:15px 0;
                    /*width:200px;*/
                    height: 20px;
                    line-height: 1;
                    /*overflow: hidden;*/
                    /*text-overflow: ellipsis;*/
                    /*white-space: nowrap;*/
                }
                .onecol{
                    text-align: left;
                    padding-left: 10px;
                }
                .imgbox{
                    width: 12px;
                    height: 12px;
                    margin-right: 10px;
                    cursor: pointer;
                    vertical-align: super;
                }
            }
            
        }
    }
</style>